import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    // Limpiar clases del body de forma segura
    if (document.body) {
      document.body.classList.remove('bg-account-pages');
      document.body.classList.remove('py-4');
      document.body.classList.remove('py-sm-0');
    }

    // Aplicar tema de forma segura
    const themeElement = document.getElementById('theme_id');
    if (themeElement) {
      themeElement.classList.remove('theme-cyan');
      themeElement.classList.remove('theme-yellow');
      
      if (this.router.url === '/') {
        themeElement.classList.add('theme-cyan');
      } else if (this.router.url === '/index9') {
        themeElement.classList.add('theme-yellow');
      }
    }
  }
}
